/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from "react";

import apiRoutes from "../utils/hooks/apiRoutes";

import imgLogin from "../assets/img/imglogin.webp";
import logo from "../assets/img/logoSI.webp";

import "../style/css/login.css";

interface LoginProps {}

const Login: React.FC<LoginProps> = () => {

  const [password, setPassword] = useState<string>("");
  const [username, setUsername] = useState<string>("");
  const [sessionToken, setSessionToken] = useState<string | null>(
    localStorage.getItem("sessionToken")
  );

  const setToken = (token: string) => {
    const expirationTime = new Date().getTime() + 60 * 60 * 6 * 1000;
    localStorage.setItem("sessionToken", token);
    localStorage.setItem("sessionTokenExpiration", expirationTime.toString());
  };

  const setSpecialToken = (token: string, tokenName: string) => {
    localStorage.setItem(tokenName, token);
  };

  const setName = (nameUser: string) => {
    localStorage.setItem("NameUser", nameUser);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault();

    try {

      const response = await fetch(apiRoutes.LoginLog, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error("Erreur lors de la connexion à l'API GLPI");
      }

      const data = await response.json();
    
      const specialTokenDev = data.specialTokens.dev;
      const specialTokenAdmin = data.specialTokens.admin;
      const specialTokenSuperAdmin = data.specialTokens.superAdmin;
      const nameUser = data.name;

      setToken(data.sessionToken);
      setSpecialToken(specialTokenDev, "specialTokenDev");
      setSpecialToken(specialTokenAdmin, "specialTokenAdmin");
      setSpecialToken(specialTokenSuperAdmin, "specialTokenSuperAdmin");
      setName(nameUser);
      setSessionToken(data.sessionToken);

      window.location.href = '/dashboard';

    } catch (error) {

      console.error("Erreur lors de la connexion:", error);
      alert("Erreur lors de la connexion. Veuillez réessayer.");

    }

  };

  const handleLogout = () => {
    
    setSessionToken(null);
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("sessionTokenExpiration");
    localStorage.removeItem("specialTokenDev");
    localStorage.removeItem("specialTokenAdmin");
    localStorage.removeItem("specialTokenSuperAdmin");
    localStorage.removeItem("NameUser");
    setUsername("");
    setPassword("");
  };

  const isTokenValid = () => {

    const expirationTime = localStorage.getItem("sessionTokenExpiration");

    if (expirationTime) {
      const currentTime = new Date().getTime();
      if (parseInt(expirationTime) <= currentTime) {
        handleLogout();
        window.location.href = "/login";
        return false;
      }
      return true;
    }

    return false;

  };

  useEffect(() => {
    if (!isTokenValid()) {
      handleLogout();
    }
  }, []);

  return (

    <main>

      <div className="mainl">

        <div className="mainl__box1">

          <div className="mainl__box1__filter">

            <img
              src={imgLogin}
              alt="vieux ordinateur"
              className="mainl__box1__filter__img"
            />

          </div>

          <div className="mainl__box1__container">

            <div className="mainl__box1__container__div">

              <p className="mainl__box1__container__div__name">Module GLPI</p>
              <p className="mainl__box1__container__div__version"> version : 1.0 </p>

            </div>

          </div>

        </div>

        <div className="mainl__box2">

          <div className="mainl__box2__container">

            <img
              src={logo}
              alt="logo SI plus"
              className="mainl__box2__container__logo"
            />
           
              <form
                className="mainl__box2__container__form"
                onSubmit={handleSubmit}
              >

                <label className="mainl__box2__container__form__label">
                  Identifiant
                  <input
                    type="text"
                    name="name"
                    className="mainl__box2__container__form__label__input"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </label>
                
                <label className="mainl__box2__container__form__label">
                  Mot de passe
                  <input
                    type="password"
                    name="mdp"
                    className="mainl__box2__container__form__label__input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </label>

                <button
                  type="submit"
                  className="mainl__box2__container__form__btn"
                >
                  Connexion

                </button>

              </form>

          </div>

        </div>

      </div>
      
    </main>
  );
};

export default Login;

